/**
 * Enthält das Formular-Model für die Reserva Suche + Funktionen zum Validieren der Personen.
 */

var $ = require('jquery');
var _ = require('underscore');
var moment = require('moment');
var Backbone = require('backbone');
var SafeStorage = require('storage/SafeStorage');
var Registry = require('registry');
var getQueryParameters = require('queryparams');

var getPeopleStructure = require('../views/PeopleStructure');

/**
 * Einen Wert als Zahl parsen und diese zurück geben. Alle anderen ungültigen Eingaben geben 0 zurück.
 */
var parseIntOrZero = function(value) {
    var result = value;
    value = parseInt(value, 10);
    if ( value > 0 ) {
        result = value;
    } else {
        result = 0;
    }
    return result;
}


var FormModel = Backbone.Model.extend({
    defaults: function() {
        return {
            "from": null,
            "to": null,

            /* Für die Vererbung in die Templates */
            "isTouchDevice": false,

            /* Anzahl Nächste */
            "nights": null, 

            /* Kalender Auswahl-Modus (none, exact, flex) */
            "select_mode": "exact",

            "rooms": 1,
            "rooms.1.type": "any",
            "rooms.1.bedrooms": 0,
            "rooms.1.adults": 2,
            "rooms.1.children": 0,
            "rooms.1.child1": 0,
            "rooms.1.child2": 0,
            "rooms.1.child3": 0,
            "rooms.1.child4": 0,
            "rooms.1.child5": 0,
            "rooms.2.type": "any",
            "rooms.2.bedrooms": 0,
            "rooms.2.adults": 2,
            "rooms.2.children": 0,
            "rooms.2.child1": 0,
            "rooms.2.child2": 0,
            "rooms.2.child3": 0,
            "rooms.2.child4": 0,
            "rooms.2.child5": 0,
            "rooms.3.type": "any",
            "rooms.3.bedrooms": 0,
            "rooms.3.adults": 2,
            "rooms.3.children": 0,
            "rooms.3.child1": 0,
            "rooms.3.child2": 0,
            "rooms.3.child3": 0,
            "rooms.3.child4": 0,
            "rooms.3.child5": 0,
        };
    },

    /* Variablen, die nicht mit dem Formular verschickt werden sollen */
    form_blacklist: [
        /* Interner App-State */
        'isTouchDevice',
        /* Schrott-Formularfelder */
        'control-nights', 'control-from', 'control-to', 'action',
    ],

    /* Felder aus dem PeopleSelect */
    peopleFields: [
        "rooms.1.adults",
        "rooms.1.children",
        "rooms.1.child1",
        "rooms.1.child2",
        "rooms.1.child3",
        "rooms.1.child4",
        "rooms.1.child5",

        "rooms.2.adults",
        "rooms.2.children",
        "rooms.2.child1",
        "rooms.2.child2",
        "rooms.2.child3",
        "rooms.2.child4",
        "rooms.2.child5",

        "rooms.3.adults",
        "rooms.3.children",
        "rooms.3.child1",
        "rooms.3.child2",
        "rooms.3.child3",
        "rooms.3.child4",
        "rooms.3.child5",
    ],

    /* Datenfelder die intern immer Integer (oder null) sein müssen */
    numberFields: [
        "rooms",
        "rooms.1.bedrooms",
        "rooms.1.adults",
        "rooms.1.children",
        "rooms.1.child1",
        "rooms.1.child2",
        "rooms.1.child3",
        "rooms.1.child4",
        "rooms.1.child5",
        "rooms.2.bedrooms",
        "rooms.2.adults",
        "rooms.2.children",
        "rooms.2.child1",
        "rooms.2.child2",
        "rooms.2.child3",
        "rooms.2.child4",
        "rooms.2.child5",
        "rooms.3.bedrooms",
        "rooms.3.adults",
        "rooms.3.children",
        "rooms.3.child1",
        "rooms.3.child2",
        "rooms.3.child3",
        "rooms.3.child4",
        "rooms.3.child5",
    ],

    /**
     * Model initialisieren
     */
    initialize: function() {
        this.form = null;
        this.boundToSafeStorage = false;
    },

    /**
     * URL-Parameter ins Model importieren
     */
    setFromQueryString: function() {
        var parameters = getQueryParameters();

        console.log("[FormModel] Parameters taken from URL:", parameters);
        this.setSafe(parameters);
    },

    /**
     * Parameter aus Formular importieren
     */
    setFromForm: function(form) {
        if ( typeof form === "undefined" ) {
            form = this.form;
        }
        if ( !this.form || !this.form.length ) {
            console.log("FormModel.setFromForm: No form supplied or bound to");
            return;
        }

        var keys = _(this.attributes).keys();
        var parameters = {};
        for (var i = 0; i < keys.length; i++) {
            let field = keys[i];

            let value = $('[name="'+field+'"]', form).val();
            if ( value ) {
                parameters[field] = value;
            }
        }

        console.log("[FormModel] Parameters taken from form:", parameters);
        this.setSafe(parameters);
    },

    /**
     * Parameter setzen und dabei die Datentypen korrigieren falls notwendig.
     */
    setSafe: function(parameters) {
        var keys = _(parameters).keys();
        
        for (var i = 0; i < this.numberFields.length; i++) {
            let field = this.numberFields[i];
            if ( parameters[field] ) {
                parameters[field] = parseInt(parameters[field], 10);
            }
        }
        this.set(parameters);
    },

    /**
     * Gibt alle Felder für das Formular zurück. Ignoriert dabei Felder, die momentan nicht sichtbar sind.
     */
    getForm: function() {
        var data = {};
        var model = this;
        var structure = getPeopleStructure(this, false);

        /* Erstmal Formulardaten verwenden */
        _.extend(data, this.getFormParameters());
        /* Danach unsere Modeldaten */
        _.extend(data, this.toJSON());

        /* Unsichtbare Felder löschen */
        _.each(structure, function(item) {
            if ( !item.condition(model) ) {
                delete data[item.key];
            }
        });

        /* Auswahlmodus Kein Datum */
        if ( data.select_mode === "none" ) {
            delete data.from;
            delete data.to;
        }

        /* Werte filtern */
        _.each(data, function(value, key) {
            /* Leere Werte */
            if ( value === null || value === "" ) {
	        	delete data[key];
            }
            /* Leere Raum-Werte interessieren nicht (außer es ist "rooms" selbst, das kann 0 sein und muss geschickt werden) */
            if ( key.indexOf('rooms.') === 0 && ( value === 0 || value === "0" ) ) {
                delete data[key];
            }
            /* Auf der Blacklist? */
            if ( this.form_blacklist.indexOf(key) !== -1 ||( key === "nights" && data.select_mode !== "flex") ) {
                delete data[key];
            }
        }.bind(this));

        /* Datumswerte serialisieren */
        if ( moment.isMoment(data.from) ) {
            data.from = data.from.format("YYYY-MM-DD");
        }
        if ( moment.isMoment(data.to) ) {
            data.to = data.to.format("YYYY-MM-DD");
        }

        return data;
    },

    /**
     * Reset the form to it's defaults. Also triggers change notifications
     */
    reset: function() {
        this.set(this.defaults());
    },

    /**
     * Zusammenfassung der Personen erzeugen. Gibt ein Objekt mit folgenden Keys zurück:
     * 
     * - rooms: Anzahl der ausgewählten Unterkünfte (Räume)
     * - adults: Anzahl der ausgewählten Erwachsenen insgesamt
     * - children: Anzahl der ausgewählten Kinder insgesamt (ohne Prüfung auf Gültigkeit)
     * - kids_ages: Liste der ausgewählten Kinder-Alter (geprüft)
     * - valid_children: Anzahl der ausgewählten Kinder insgesamt (mit ausgewähltem Alter)
     * - missing_kids_age: Fehlen Altersangaben? (bool)
     */
    getPeople: function() {

        var rooms = parseIntOrZero(this.get("rooms"));
        var adults = 0;
        var children = 0;
        var children_ages = [];
        var valid_children = 0;
        var missing_kids_age = false;

        for (var i = 1; i <= rooms; i++) {
            var prefix = "rooms." + i + ".";
            var room_kidscount = parseIntOrZero(this.get(prefix + "children"));

            adults += parseIntOrZero(this.get(prefix + "adults"));
            children += room_kidscount;

            for ( var j = 1; j <= 5; ++j ) {
                if ( room_kidscount >= j ) {
                    var age = parseIntOrZero(this.get(prefix + "child" + j));
                    if ( age > 0 ) {
                        valid_children++;
                        children_ages.push(age);

                    } else {
                        missing_kids_age = true;
                    }
                }
            }
        }

        children_ages.sort(function(a, b) {return a - b});

        return {
            rooms: rooms,
            adults: adults,
            children: children,
            children_ages: children_ages,
            valid_children: valid_children,
            missing_kids_age: missing_kids_age,
        };
    },

    /**
     * Gibt einen String zurück, der die Personen in Textform beschreibt
     */
    getPeopleString: function(people) {
        if ( typeof people === "undefined" ) people = this.getPeople();
        var text = "";
        var short_text = Registry.get("PeopleSelect.ShortText");
        var roomTitleMap = {
            any: __("housing_any"),
            room: __("housing_room"),
            single: __("housing_single"),
            double: __("housing_double"),
            flat: __("housing_flat"),
            house: __("housing_house"),
            campsite: __("housing_campsite"),
        };

        if ( people.rooms === 0 ) {
            return __("people_any_count");
        }

        if ( people.rooms > 1 ) {
            text += people.rooms + " " + __("housings") + ", "; // neutral wg. Zimmer/Fewo/Bett
        }
        
        if ( people.valid_children ) {
            text += (people.adults > 0) ? people.adults + " " + __("adults") + ", " : " " + __("no_adults") + ", ";
            text += people.valid_children + " " + (people.valid_children > 1 ? __("children") : __("child"));
        } else {
            text += (people.adults > 1) ? people.adults + " " + __("adults") + "" : " 1 " + __("adult");
        }

        if ( people.rooms === 1 && Registry.get("PeopleStructure.ShowRoomTypes") ) {
            var roomTypeTitle = roomTitleMap[this.get("rooms.1.type")];
            text += " in " + roomTypeTitle;
        }

        if ( short_text ) {
            var parts = [];
            if ( people.rooms > 1 )          parts.push(people.rooms + "U");
            if ( people.adults > 0 )         parts.push(people.adults + "E");
            if ( people.valid_children > 0 ) parts.push(people.valid_children + "K");
            text = parts.join(" + ");
        }

        return text;
    },

    /**
     * Bindet das Model an ein HTML-Formular. Alle Änderungen werden entsprechend dem Formular zugewiesen.
     * Nicht im Formular vorhandene Felder werden als hidden Felder erzeugt (praktisch für die Personen).
     */
    bindToForm: function(form) {
        this.form = form;

        this.on('change', function(e) {
            _.each(e.changed, function(value, key) {
                if ( _.indexOf(this.form_blacklist, key) >= 0 ) return;

                var input = form.find("[name='"+key+"']");
                if ( input.length === 0 ) {
                    console.log(`FormModel: Add input '${key}' to form`, form);
                    input = $('<input/>').attr({
                        'type': 'hidden',
                        'name': key
                    }).appendTo(form);
                }
                input.val(value);
            }.bind(this));
        }.bind(this));
    },

    /**
     * Setzt alle Attribute vom FormModel zum verbundenen Formular.
     * Praktisch für Such-Sonderfälle wie das Backend.
     */
    updateForm: function(form, create_inputs=true) {
        form = form || this.form;
        if ( !form ) {
            throw new Error("[FormModel] Tried to updateForm without a form");
        }

        _.each(this.attributes, function(value, key) {
            if ( _.indexOf(this.form_blacklist, key) >= 0 ) return;

            var input = form.find("[name='"+key+"']");
            if ( input.length === 0 && create_inputs ) {
                console.log(`FormModel: Add input '${key}' to form`, form);
                input = $('<input/>').attr({
                    'type': 'hidden',
                    'name': key
                }).appendTo(form);
            }
            input.val(value);
        }.bind(this));
    },

    /**
     * Alle Parameter aus dem Formular ermitteln und in ein Objekt packen
     */
    getFormParameters: function() {
        if ( !this.form ) return {};

        var params = {};
        this.form.find('[name]').each(function(i, item) {
            var $item = $(item);
            params[$item.attr('name')] = $item.val();
        });
        return params;
    },

    /**
     * Bindet das Model an das localStorage. Alle Änderungen werden dort gespeichert.
     */
    bindToLocalStorage: function() {
        this.on('change', function(e) {
            _.each(e.changed, function(value, key) {
                SafeStorage.local.set("ReservaForm:" + key, value);
            });
        });
        this.boundToSafeStorage = true;
    },

    /**
     * URL-Parameter ins Model importieren
     */
    setFromLocalStorage: function() {
        if ( this.boundToSafeStorage ) {
            throw new Error("Please call setFromLocalStorage before bindToLocalStorage");
        }

        var keys = _(this.attributes).keys();
        var new_values = {};
        for(var i = 0, key; key = keys[i]; ++i) {
            var cached = SafeStorage.local.get("ReservaForm:" + key);
            if ( cached ) {
                if ( this.numberFields.indexOf(key) !== -1 ) {
                    cached = parseInt(cached, 10);
                }
                new_values[key] = cached;
            }
        }

        console.log("[FormModel] Parameters take from localStorage:", new_values);
        this.set(new_values);
    },

    /**
     * Formulardaten validieren
     */
    validate: function(data) {
        let errors = [];

        /* Dates */
        if ( data.select_mode !== "none" ) {
            var date_from = moment(data.from, "YYYY-MM-DD");
            var date_to = moment(data.to, "YYYY-MM-DD");

            if ( !date_from.isValid ) {
                errors.push("Das Ankunfsdatum ist nicht korrekt: " + data.from);
            }
            if ( !date_to.isValid ) {
                errors.push("Das Ankunfsdatum ist nicht korrekt: " + data.to);
            }

            if ( date_to.diff(date_from, "days") > 21 ) {
                errors.push("Eine Suche ist für maximal 21 Tage möglich.")
            }
        }

        /* Kinder */
        for ( var room_id = 1; room_id <= data.rooms; ++room_id ) {
            var children = data["rooms." + room_id + ".children"];
            for(var i = 1; i <= children; ++i ) {
                if ( ! data["rooms." + room_id + ".child" + i] ) {
                    errors.push("Unterkunft " + room_id + " Kind " + i +  ": Alter fehlt");
                }
            }
        }

        return errors;
    },

    /**
     * Beim Suchagent gibt es folgendes Problem:
     * - Wir haben select-Felder für die Personenauswahl
     * - Der Server gibt im Formular die gleichen Felder nochmals
     *   als <input type="hidden"> aus, daher sind die Felder nun doppelt
     * - Der submit geht kaputt wegen der Backend-Behandlung von Mehrfachfeldern
     *
     * Diese Funktion findet doppelte Felder und löscht die hidden-Elemente raus.
     */
    fixSearchAgentForm: function(form) {
        console.log("fixSearchAgentForm", form, this.form);
        if ( typeof form === "undefined" ) {
            form = this.form;
        }
        if ( !this.form || !this.form.length ) {
            console.log("FormModel.fixSearchAgentForm: No form supplied or bound to");
            return;
        }

        _.each(this.attributes, function(value, key) {
            if ( _.indexOf(this.form_blacklist, key) >= 0 ) return;

            var input = form.find("input[name='"+key+"']");
            var select = form.find("select[name='"+key+"']");

            console.log(input, select);

            if ( input.length > 0 && select.length > 0 ) {
                let input_value = input.val();
                if ( input_value ) {
                    select.val(input_value);
                }
                console.log(`fixSearchAgentForm: Dropping hidden field`, key);
                input.remove();
            }

        }.bind(this));
    }

});

module.exports = FormModel;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/models/FormModel.js